import React from 'react'
import ChartContainer from '../../components/analytics/ChartContainer'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import CustomTooltip from '../../components/analytics/CustomTooltip';
import CustomLegend from '../../components/analytics/CustomLegend';

const DesktopVsMobileApplications = ({
    isLoading,
    errorMessage,
    isValueZero,
    data,
    chartDescription
}) => {

    const renderCustomLegend = (props) => {
        const { payload } = props;
        return (
            <ul style={{ display: 'flex', justifyContent: 'center', listStyleType: 'none', padding: 0, margin: '10px 0' }}>
                {payload.map((entry, index) => (
                    <li
                        key={`item-${index}`}
                        style={{
                            marginRight: '20px',
                            fontSize: '14px', // Set font size
                            textTransform: 'capitalize', // Capitalize case
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        <span
                            style={{
                                width: '10px',
                                height: '10px',
                                backgroundColor: entry.color,
                                display: 'inline-block',
                                marginRight: '8px',
                            }}
                        ></span>
                        {entry.value.toLowerCase()} {/* Ensure lowercase before applying capitalize */}
                    </li>
                ))}
            </ul>
        );
    };

    return (
        <ChartContainer
            title="Desktop (vs) Mobile IDV Applications"
            chartDescription={chartDescription}
            isLoading={isLoading}
            errorMessage={errorMessage}
            isValueZero={isValueZero}
        >
            <BarChart
                data={data}
                width={460} height={320}
                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="month" interval={0} fontSize={12} />
                <YAxis fontSize={12} />
                <Tooltip
                    content={
                        <CustomTooltip
                            labelFormatter={(label) => `Month: ${label}`}
                            valueFormatter={(value) => `${value}`}
                        />
                    }
                />
                <Legend content={<CustomLegend />} />
                <Bar dataKey="desktop" stackId="a" fill="#8884d8" />
                <Bar dataKey="mobile" stackId="a" fill="#82ca9d" />
            </BarChart>
        </ChartContainer>
    )
}

export default DesktopVsMobileApplications